import { JOURNEY_BUILDER } from 'constants/actionTypes';
import reduceUI from './ui';

const journeyBuilderReducer = (state = {}, action = {}) => {
  const updateState = changes => ({ ...state, ...changes });

  switch (action.type) {
    case JOURNEY_BUILDER.JOURNEY.UPDATE_AUTOSAVE:
      return updateState({
        autosavedAt: action.payload.autosavedAt,
      });
    case JOURNEY_BUILDER.JOURNEY.UPDATE_DETAILS:
      return updateState({
        title: action.payload.title,
        description: action.payload.description,
      });
    case JOURNEY_BUILDER.STEPS.ADD:
      if (action.payload.index >= state.steps.length) {
        state.steps.push(action.payload.step);
      } else {
        state.steps.splice(action.payload.index, 0, action.payload.step);
      }
      return updateState({
        steps: state.steps,
      });
    case JOURNEY_BUILDER.STEPS.UPDATE:
      state.steps.splice(action.payload.index, 1, action.payload.step);

      return updateState({
        steps: state.steps,
      });
    case JOURNEY_BUILDER.STEPS.REMOVE:
      state.steps.splice(action.payload.index, 1);

      return updateState({
        steps: state.steps,
      });
    case JOURNEY_BUILDER.STEPS.REORDER:
      return updateState({
        steps: action.payload,
      });
    default: {
      return {
        ...state,
        ui: reduceUI(state.ui, action),
      };
    }
  }
};

export default journeyBuilderReducer;
